import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default, { forwardRef, useRef, useState, useMemo } from 'react';
import './Input.scss.js';
import { useDebounce } from '../../../hooks/useDebounce.js';
import { useUncontrolled } from '../../../hooks/useUncontrolled.js';
import AllClose from '../../../assets/icons/resultDir/AllClose.js';

var Input = /*#__PURE__*/forwardRef(function (_a, ref) {
  var className = _a.className,
      inputClassName = _a.inputClassName,
      onClear = _a.onClear,
      _a$debounce = _a.debounce,
      debounce = _a$debounce === void 0 ? 300 : _a$debounce,
      icon = _a.icon,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'base' : _a$variant,
      startAdornment = _a.startAdornment,
      endAdornment = _a.endAdornment,
      disabled = _a.disabled,
      readOnly = _a.readOnly,
      invalid = _a.invalid,
      _a$filled = _a.filled,
      filled = _a$filled === void 0 ? true : _a$filled,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      onDebounce = _a.onDebounce,
      _a$isBorder = _a.isBorder,
      isBorder = _a$isBorder === void 0 ? true : _a$isBorder,
      pattern = _a.pattern,
      valueProp = _a.value,
      defaultValueProp = _a.defaultValue,
      props = __rest(_a, ["className", "inputClassName", "onClear", "debounce", "icon", "variant", "startAdornment", "endAdornment", "disabled", "readOnly", "invalid", "filled", "onFocus", "onBlur", "onChange", "onDebounce", "isBorder", "pattern", "value", "defaultValue"]);
  /** Ref */


  var inputRef = useRef(null);
  /** Значение поля */

  var _useUncontrolled = useUncontrolled({
    value: valueProp,
    defaultValue: defaultValueProp,
    finalValue: ''
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      value = _useUncontrolled2[0],
      setValue = _useUncontrolled2[1];
  /** Находится ли инпут в состоянии фокуса */


  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setFocused = _useState2[1]; // Регулярное выражение для проверки ввода


  var regexp = useMemo(function () {
    if (pattern) {
      return new RegExp(pattern);
    }

    return null;
  }, [pattern]); // ------------------------------------------------------------------------------------------------------------------

  useDebounce(value, debounce, function (v) {
    if (onDebounce) {
      onDebounce({
        debounceString: v.toString()
      });
    }
  }); // ------------------------------------------------------------------------------------------------------------------

  /** Очистка поля ввода и сброс результатов поиска */

  var clearInput = function clearInput() {
    setValue('');
    onDebounce && onDebounce({
      debounceString: ''
    });
    onClear && onClear();
  };
  /** Кнопка поиска и сброса */


  var closeButton = onClear && value.length > 0 && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "rf-input__action",
    onClick: clearInput,
    "aria-label": "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(AllClose, {
    "data-v-6e52f9c7": ""
  })); // ------------------------------------------------------------------------------------------------------------------

  var onInputFocus = function onInputFocus(event) {
    setFocused(true);

    if (onFocus) {
      onFocus(event);
    }
  };

  var onInputBlur = function onInputBlur(event) {
    setFocused(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    if (regexp && !regexp.test(event.target.value)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    setValue(event.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  }; // ------------------------------------------------------------------------------------------------------------------
  // Делаем проверку на className для обратной совместимости.


  var isInvalid = invalid || className && className.indexOf('invalid') !== -1;
  return /*#__PURE__*/React__default.createElement("label", {
    ref: ref,
    className: "\n        rf-input \n        ".concat(variant === 'inline' ? 'rf-input--inline' : '', " \n        ").concat(disabled ? 'rf-input--disabled' : '', " \n        ").concat(readOnly ? 'rf-input--readonly' : '', " \n        ").concat(isFocused ? 'rf-input--focused' : '', " \n        ").concat(isInvalid ? 'rf-input--invalid' : '', " \n        ").concat(filled ? 'rf-input--filled' : '', "\n        ").concat(className || '', "\n        ").concat(isBorder ? '' : 'rf-input--non-border', "\n        "),
    "data-v-6e52f9c7": ""
  }, !!startAdornment && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-input__adornment rf-input__adornment--start",
    "data-v-6e52f9c7": ""
  }, startAdornment), /*#__PURE__*/React__default.createElement("input", _extends({}, props, {
    value: value,
    ref: inputRef,
    className: "rf-input__field ".concat(inputClassName || ''),
    autoComplete: "off",
    type: props.type || 'text',
    disabled: disabled,
    readOnly: readOnly,
    onChange: handleInputChange,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    pattern: pattern,
    "data-v-6e52f9c7": ""
  })), !!endAdornment && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-input__adornment rf-input__adornment--end",
    "data-v-6e52f9c7": ""
  }, endAdornment), icon ? /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "rf-input__action",
    "data-v-6e52f9c7": ""
  }, icon) : closeButton);
});

export { Input as default };
